import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { strings, getCurrentLocale } from 'APP_ROOT/localization';

import Analytics from 'APP_ROOT/services/analytics';
import Events from '../../common/events';
import MainModuleGroup from 'APP_ROOT/components/LayoutTemplateModularFullscreen/MainModuleGroup';
import MapboxMap from '../../mapbox/mapboxMapDashboardContainer'; // import MapboxMap from '../../mapbox/mapboxMap';
import NoRavensError from '../errors/noRavensError';
import OverdueError from '../errors/OverdueError';
import OverdueModal from '../errors/OverdueModal';


import RavenInviteModal from '../../../components/pages/account/ravenInviteModal';

import SettingsSelectors from 'APP_ROOT/data/settings/selectors';
import { loadSettings } from 'APP_ROOT/data/settings/actions';
import { ACTIONS as layoutTemplateModularFullscreenDispatchActions, ACTIVE_MENU_ITEM_IDS } from 'APP_ROOT/data/layoutTemplateModularFullscreen/duck';
import geofences from 'APP_ROOT/data/geofences';
import Permissions from '../../../data/permissions';
import { Selectors as tagsSelectors } from '../../../data/tags';

import { RESOURCE_GROUP_TYPES } from './ResourceGroups/constants';
import ResourceGroups from './ResourceGroups';
import ResourceDetails from './ResourceDetails';
import EnhancedVideoAccess from './EnhancedVideoAccess/EnhancedVideoAccess';
import { setSelectedResource } from './actions';

import { Selectors as AssetMonitoringSelectors, DispatchHelpers as AssetMonitoringActions } from '../../../data/assetMonitoring';
import TagPermissions from '../../common/tagsPermissions';

const LEGACY_FONT_SIZE = 16;
const BASE_FONT_SIZE = 14;
const CSS_MEDIA_MIN_WIDTH = 1200 * (BASE_FONT_SIZE/LEGACY_FONT_SIZE); // corresponds to the CSS entries like '@media (min-width:1200px)'. If below this width, panels must be visible (consider this as something like 'tablet mode')
const DEFAULT_UOM = 'IMPERIAL';

class DashboardPage extends Component {

    constructor(props) {

        super(props);

        this.ravensLoaded = false;

        this.state = {
            detailsPanelIsOpen: true,              // Required for the edit mode component to display save/cancel controls if details panel's location controls are not shown
            overdueModalOpen: true,
            enhancedVideoAccessModeActive: false,
        }
    }

    componentDidMount() {
        Analytics.pageView();
        if (!this.props.ravens) this.props.getUserData(this.loadDashboard);
        else this.loadDashboard();

        this.lastProps = this.props;

        // On first load
        this.adjustPanels();

        this.props.enableDFast(true);

        document.addEventListener(Events.REFRESH_MEDIA, this.onRefreshMediaEvent);

        if (this.props.fromSnapshot){
            this.props.updateFromSnapshot(false);
        }
        if(this.props.tags && this.props.ravens) {
            TagPermissions.setData(this.props.user, {tags: this.props.tags, ravens: this.props.ravens});
        }
    }

    closeOverdueModal = () => {
        this.setState({
            overdueModalOpen: false
        });
    }

    // Wrapper around this.props.loadDashboard() to ensure that the settings are loaded
    loadDashboard = () => {
        this.props.loadDashboard();
        if (!this.props.mainNavigationActiveMenuItemId) { // no activeMenuItemId means no menu click (loading from url)

            if(this.props.match.params.resourceType && this.props.match.params.resourceId) {
                const cleanedResourceType = this.props.match.params.resourceType.replace(/s$/, '').toUpperCase(); // remove trailing 's' from resourceType and convert to uppercase

                const resourceType = RESOURCE_GROUP_TYPES[cleanedResourceType] || RESOURCE_GROUP_TYPES.VEHICLE;
                const resourceId = this.props.match.params.resourceId;

                this.selectResource(resourceType, resourceId);
            }
            else{
                switch (this.props.selectedResource.resourceType) { // if a resource has been persisted in local storage
                    // automatically switch based on the persisted selected resource type
                    case RESOURCE_GROUP_TYPES.ASSET:
                        this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.DASHBOARD_ASSET);
                        break;
                    case RESOURCE_GROUP_TYPES.GEOFENCE:
                        this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.DASHBOARD_GEOFENCE);
                        break;
                    case RESOURCE_GROUP_TYPES.VEHICLE:
                    case RESOURCE_GROUP_TYPES.RAVEN:
                    default: // 'default' handles edge case if no selected resource on a url direct link:
                        this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.DASHBOARD_VEHICLE);
                        break;
                }
            }
        }
        if (!this.props.settingsLoaded) {
            this.props.loadSettings();
        }
    }

    onRefreshMediaEvent = e => {
        const selectedRavenUuid = this.props.selectedRaven && this.props.selectedRaven.ravenUuid;
        if (selectedRavenUuid) {
            document.dispatchEvent(new CustomEvent(Events.REFRESH_RAVEN, { detail: { ravenUuid: selectedRavenUuid } }));
        }
    }

    toggleEnhancedVideoAccessModeActive = () => {
        const isActive = !this.state.enhancedVideoAccessModeActive;
        this.setState({
            enhancedVideoAccessModeActive: isActive
        })
        if (!isActive) {
            const selectedRaven = this.props.selectedRaven ? this.props.selectedRaven : {};
            Events.enhancedVideoAccessRouteHighlightRequest(selectedRaven.ravenUuid, 0, 0); // <-- clear any current highlight
        }
    }

    componentWillUnmount() {
        this.props.enableDFast(false);

        document.removeEventListener(Events.REFRESH_MEDIA, this.onRefreshMediaEvent);

        if(this.props.geofenceGeometryEditModeActive) {
            this.props.cancelGeofenceGeometryEditMode();
        }

        if(this.props.assetEditModeActive) {
            this.props.cancelAssetEditMode();
        }
    }

    componentDidUpdate(prevProps) {

        if(this.props.tags && this.props.ravens && 
            (prevProps.tags !== this.props.tags || 
            prevProps.ravens !== this.props.ravens)) {
            TagPermissions.setData(this.props.user, {tags: this.props.tags, ravens: this.props.ravens});
        }

        const currentSelectedResourceId = this.props.selectResource ? this.props.selectResource.resourceId : null;
        const prevSelectedResourceId = prevProps.selectResource ? prevProps.selectResource.resourceId : null;

        if (prevSelectedResourceId !== currentSelectedResourceId) {
            if (this.state.enhancedVideoAccessModeActive) {
                this.toggleEnhancedVideoAccessModeActive();
            }
        }
        this.adjustPanels();
        // ensure the Details panel heading title is consistent with the selected resource
        switch (this.props.selectedResource.resourceType) {
            case RESOURCE_GROUP_TYPES.RAVEN:
            case RESOURCE_GROUP_TYPES.VEHICLE:
                this.props.setMainModuleGroupDetailsTitle(strings.vehicle_details_title);
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                this.props.setMainModuleGroupDetailsTitle(strings.asset_details_title);
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                this.props.setMainModuleGroupDetailsTitle(strings.geofences_details_title);
                break;
            default:
                break;
        }
        if (this.props.mainNavigationActiveMenuItemId !== prevProps.mainNavigationActiveMenuItemId) {
            if (this.props.selectedResource.resourceType && (this.props.selectedResource.resourceType !== this.props.mainModuleGroupSelectedResourceType)) {
                this.props.setMainModuleGroupDetails(true); // isCollapsed true
            }
        }
    }

    adjustPanels() {

        if(!this.ravensLoaded)
        {
            if(this.props.ravens && this.props.ravens.length !== 0)
            {
                this.ravensLoaded = true;
                // if no resource selected, auto-select one
                if (this.props.hasOwnProperty("selectedResource")) {
                    if (!this.props.selectedResource.resourceType || !this.props.selectedResource.resourceId) {
                        const type = RESOURCE_GROUP_TYPES.VEHICLE;
                        const id = this.props.ravens[0].ravenUuid;
                        this.selectResource(type, id);
                    }
                }
                /*
                // If there is only 1 Raven on the account, show the bottom panel
                if (this.props.ravens.length < 2)
                {
                    this.props.togglePanels(false, true);
                } else {
                    if (window.innerWidth < CSS_MEDIA_MIN_WIDTH) {
                        this.props.togglePanels(true, true); // RAV-360, both panels open by default on mobile layout
                    } else {
                        this.props.togglePanels(true, false); // RAV-360, set the side panel as open by default for fleet-like users (2 or more users)
                    }
                }*/
            }
        }
    }

    setDetailPanelOpen = open => {
        this.props.setDetailPanelOpen(open);
    }

    onGoLiveClick = (e) => {

        //reload the page, since now when raven isn't "in dfast mode", it doesn't save up points to send; it just doesn't send them.
        //When resuming dfast mode, it starts sending data at the latest points.
        //this leaves a gap in the route data, causing the car to animate from the last known point to the latest point from raven
        //this will happen over the time between the two points (which could be minutes or even hours), causing a horrible UX.
        //simplest solution is to reload the page to fetch a new query.
        // window.location.reload();
        this.loadDashboard();
    }

    selectResource = (type, id, isUserClick = true) => {
        switch (type) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
            case RESOURCE_GROUP_TYPES.RAVEN:
                this.props.onSelectRaven(id);
                if (isUserClick) { // RAV-3555 (usually selectResource is triggered by a user action. At time of writing, mapboxMapDashboard is a recent outlier (commit 184494c, triggers onSelectResource to load route data))
                    this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.DASHBOARD_VEHICLE);
                }
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                if (isUserClick) { // RAV-3555
                    this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.DASHBOARD_ASSET);
                }
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                if (isUserClick) { // RAV-3555
                    this.props.setMainNavigationActiveMenuItemId(ACTIVE_MENU_ITEM_IDS.DASHBOARD_GEOFENCE);
                }
                break;
            default:
                break;
        }

        // RAV-5430 : I try to explain the issue as clearly as I can: 
        // As we show the New Asset (which is not saved yet and is being edited in Details Panel) in the Asset List (contrary to geofences or ravens), 
        // there is always an asset with uuid of undefined in the Assets List which always get selected
        //  even when other items are being selected by user (while it's active in Details Panel in edit mode)
        // So we need to check if the selected resource is an asset and is in edit mode, then we should cancel it before selecting the new resource
        if(this.props.assetEditModeActive) {
            this.props.cancelAssetEditMode();
        }

        this.props.setSelectedResource(type, id);
    }


    renderRavenFromSnapshot = () => {
        if (this.props.fromSnapshot){
            
        }
    }

    render() {
        if (!this.props.ravens || this.props.ravens.length === 0) {

            // notify the user if all Ravens are overdue
            if( this.props.overdueRavens && this.props.overdueRavens.length !== 0)
            {
                return (
                    <div id="dashboardPage" className="container page-container dashboard-page">
                        <OverdueError {...this.props} />
                    </div>
                )
            }
            else
            {
                return (
                    <div id="dashboardPage" className="container page-container dashboard-page">
                        <NoRavensError {...this.props} />
                    </div>
                )
            }
        } else {

            // Note Performance Optimization: current speed is called out specificially for the
            // details panel to ensure that it gets updated when the speed does as ResourceDetails is
            // a pure component
            const funcProps = {
                onSelectResource: this.selectResource,
                setDetailPanelOpen: this.setDetailPanelOpen,
            };

            var overdueRavens = false;

            if(this.props.overdueRavens && this.props.overdueRavens.length !== 0)
            {
                overdueRavens = true;
            }

            const selectedRaven = this.props.selectedRaven ? this.props.selectedRaven : {};

            let renderMainModuleGroupNavigation = true;
            if((this.props.mainNavigationActiveMenuItemId === ACTIVE_MENU_ITEM_IDS.DASHBOARD_ASSET && !this.props.hasAccessToAssets) ||
            (this.props.mainNavigationActiveMenuItemId === ACTIVE_MENU_ITEM_IDS.DASHBOARD_GEOFENCE && !this.props.hasAccessToGeofences)) {
                renderMainModuleGroupNavigation = false;
            }
            
            return (
                <div id="dashboardPage" className={"dashboard-page language-subtag-" + getCurrentLocale()}>
                    <MainModuleGroup

                        fromSnapshot = {this.props.fromSnapshot}
                        updateFromSnapshot = {this.props.updateFromSnapshot}

                    
                        // dashboard sections
                        mainModuleGroupNavigation = {
                            renderMainModuleGroupNavigation ? <ResourceGroups selectedRavenUuid={selectedRaven.ravenUuid} {...this.props} {...funcProps}/> : null
                        }                     

                        //mainModuleGroupNavigationTitle = {strings.resource_group_title_default} // updated via Redux layoutTemplateModularFullscreen's setMainModuleGroupNavigationTitle() in this componentDidMount or MainNavigation onClicks

                        // side panel
                        mainModuleGroup = {
                            <MapboxMap
                                {...this.props}
                                {...funcProps}
                                mapId="dashboardMap"
                                detailsPanelIsOpen = {this.state.detailsPanelIsOpen}
                                geofenceGeometryEditModeActive = {this.props.geofenceGeometryEditModeActive}
                                stage={this.props.user.stage}
                                updateKey={this.props.mapUpdateKey}
                            />
                        }

                        // MainNavigation selected resource is menu-item-specifc and can differ from the user-selected resource
                        // This allows the MainNavigation selected item state to change without forcing the sessionManager's selectedResource to follow suit
                        // However, sessionManagerSelectedResourceResourceType can be provided to allow for special styling options
                        sessionManagerSelectedResourceResourceType = {this.props.selectedResource ? this.props.selectedResource.resourceType : undefined}

                        enhancedVideoAccessModeActive = {this.state.enhancedVideoAccessModeActive}

                        mainModuleGroupDetailsEVAPanel = {
                            this.state.enhancedVideoAccessModeActive ?
                                <EnhancedVideoAccess
                                    toggleEnhancedVideoAccessModeActive = {this.toggleEnhancedVideoAccessModeActive}
                                    stage = {this.props.user.stage}
                                    mapUpdateKey = {this.props.mapUpdateKey} /* sync pureComponent props updates/renders with the map (dashboard, possibly also history) */
                                    ravenId = {selectedRaven.ravenUuid}
                                    cardId = {selectedRaven.dashboard ? this.props.selectedRaven.dashboard.cardId : undefined}
                                    selectedEvent = {this.props.selectedEvent}
                                    startGeostamp = {selectedRaven.dashboard ? this.props.selectedRaven.dashboard.start : undefined}
                                    endGeostamp = {selectedRaven.dashboard ? this.props.selectedRaven.dashboard.end : undefined}
                                    route = {selectedRaven.dashboard ? this.props.selectedRaven.dashboard.route : undefined}
                                    events = {selectedRaven.dashboard ? this.props.selectedRaven.dashboard.events : undefined}
                                />
                            :
                                null
                        }

                        // bottom panel
                        mainModuleGroupDetails = {
                            <ResourceDetails
                                {...this.props}
                                {...funcProps}
                                stage={this.props.user.stage}
                                theme={this.props.theme}
                                features={this.props.features}
                                enhancedVideoAccessModeActive={this.state.enhancedVideoAccessModeActive}
                                toggleEnhancedVideoAccessModeActive={this.toggleEnhancedVideoAccessModeActive}
                                selectedRaven={this.props.selectedRaven}
                                selectedResource={this.props.selectedResource}
                                selectedEvent={this.props.selectedEvent}
                                onSelectEvent={this.props.onSelectEvent}
                                mqttService={this.props.mqttService}
                                unitOfMeasure={this.props.unitOfMeasure ? this.props.unitOfMeasure.toUpperCase() : DEFAULT_UOM}
                                currentSpeed={this.props.selectedRaven && this.props.selectedRaven.vehicleState ?
                                    this.props.selectedRaven.vehicleState.currentSpeed : null }
                                unplugged={this.props.selectedRaven ? this.props.selectedRaven.unplugged : null}
                                sdCardStatus={this.props.selectedRaven ? this.props.selectedRaven.sdCardStatus : null}
                                geofenceGeometryEditModeActive = {this.props.geofenceGeometryEditModeActive}
                                showcaseTargetRavenUuid={this.props.showcaseTargetRavenUuid}
                                pokeMap={this.props.pokeMap}
                            />
                        }

                        //mainModuleGroupDetailsTitle = {strings.action_details} // updated via Redux layoutTemplateModularFullscreen's setMainModuleGroupDetailsTitle() in this componentDidMount or MainNavigation onClicks

                    />
                    { overdueRavens ?
                        <OverdueModal 
                            isOpen={this.state.overdueModalOpen}
                            onRequestClose={this.closeOverdueModal}
                        /> :
                        null
                    }

                    <RavenInviteModal currentUserEmail={this.props.user.email} user={this.props.user} />
                </div>
            )
        }
    }
}

const NEW_GEOFENCE_RESOURCE_DESCRIPTOR = { resourceType: 'geofence' };
const NEW_ASSET_RESOURCE_DESCRIPTOR = { resourceType: 'asset' };

const mapStateToProps = (state, ownProps) => {
    const { layoutTemplateModularFullscreenSharedState } = state.data; // state data for layoutTemplateModularFullscreenSharedState reducer
    return {
        hasAccessToGeofences: Permissions.selectors.can(state, 'geofences', 'read'),
        hasAccessToAssets: Permissions.selectors.can(state, 'assets', 'read'),
        tags: tagsSelectors.tags(state),
        tagsLoaded: tagsSelectors.loaded(state),
        tagsError: tagsSelectors.error(state),
        tagsPending: tagsSelectors.pending(state),
        tagsLoading: tagsSelectors.loading(state),
        settingsLoaded: SettingsSelectors.settingsLoaded(state),
        unitOfMeasure: SettingsSelectors.unitOfMeasure(state),
        selectedResource: geofences.Selectors.newGeofence(state) ? NEW_GEOFENCE_RESOURCE_DESCRIPTOR : AssetMonitoringSelectors.activeNewAsset(state) ? NEW_ASSET_RESOURCE_DESCRIPTOR : state.scenes.dashboard.selectedResource,
        geofenceGeometryEditModeActive: !!geofences.Selectors.editingGeometry(state),
        assetEditModeActive: AssetMonitoringSelectors.assetEditModeActive(state),
        ...layoutTemplateModularFullscreenSharedState
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadSettings: () => dispatch(loadSettings(ownProps.user && ownProps.user.stage)),
        setSelectedResource: (type, id) => dispatch(setSelectedResource(type, id)),
        cancelGeofenceGeometryEditMode: () => dispatch(geofences.Actions.cancelGeometryEdit()),
        cancelAssetEditMode: (assetUuid) => dispatch(AssetMonitoringActions.cancelAssetEdit(assetUuid)),
        togglePanels: (mainModuleGroupNavigationIsCollapsed, mainModuleGroupDetailsIsCollapsed) => {
            return; // RAV-2973 disabling legacy dashboard-driven auto toggling
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupNavigation(mainModuleGroupNavigationIsCollapsed));
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupDetails(mainModuleGroupDetailsIsCollapsed));
        },
        setDetailPanelOpen: (mainModuleGroupDetailsIsOpen) => {
            const mainModuleGroupDetailsIsCollapsed = !mainModuleGroupDetailsIsOpen;
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupDetails(mainModuleGroupDetailsIsCollapsed));
        },
        setMainNavigationActiveMenuItemId: (activeMenuItemId) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainNavigationActiveMenuItemId(activeMenuItemId));
            return;
        },
        setMainModuleGroupDetailsTitle: (title) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupDetailsTitle(title));
            return;
        },
        setMainModuleGroupDetails: (isCollapsed) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupDetails(isCollapsed));
            return;
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);

